import {Box,Typography,Button, CircularProgress, RadioGroup, FormLabel, FormControl, FormControlLabel, Radio} from "@mui/material"
import EditorText from "./EditorText"

const TrainQuestionView = ({content,score,title,subTime,time,setMessage,hasEnded,message,handleSend,questions,count,submitting,currentQuestion,totalQuestions})=>{
    
    return (
        <Box style={{width:450}}>
            <Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
                <Typography style={{color:'white'}}>
                    {title}
                </Typography>
                <Typography pl={2} style={{color:"gold",fontSize:13,width:200}}>
                    {time}
                </Typography> 
            </Box>
            <Typography m={1} style={{color:"gold",fontSize:13,width:200}}>
                {subTime}
            </Typography> 
            <Typography m={1} style={{color:"gold",fontSize:15,width:200}}>
                {currentQuestion}/{totalQuestions}
            </Typography> 
            <Box sx={{justifyContent:"flex-start",alignItems:"flex-start",margin:1}}>
            {
                    hasEnded ?
                        <>
                            {
                                submitting ?

                                <CircularProgress size={20} sx={{color:"#fff"}}/>
                            :
                            <Box>
                                <Typography sx={{fontSize:15,padding:1,whiteSpace:"pre-wrap"}}>
                                    We thank you for taking this assessment
                                </Typography>
                                <Typography sx={{fontSize:14,fontFamily:"dinofans",padding:1}}>
                                    View the result
                                </Typography>

                                {
                                    content?.test?.map((item,index)=>{
                                        return(
                                            <Box key={index} sx={{width:"100%"}}>
                                                <Typography sx={{fontSize:14,fontFamily:"dinofans",padding:1}}>
                                                    {index+1}. Question
                                                </Typography>
                                                <Typography sx={{fontSize:15,padding:1,whiteSpace:"pre-wrap"}}>
                                                    {item?.question}
                                                </Typography>
                                                <Typography sx={{fontSize:14,fontFamily:"dinofans",padding:1}}>
                                                    Type
                                                </Typography>
                                                <Typography sx={{fontSize:15,padding:1,whiteSpace:"pre-wrap"}}>
                                                    {item?.type}
                                                </Typography>
                                                <Typography sx={{fontSize:14,fontFamily:"dinofans",padding:1}}>
                                                    Your answer
                                                </Typography>
                                                <Typography sx={{fontSize:15,padding:1,color:(item?.isCorrect ? "green" : "red")}}>
                                                    {item?.candidate_answer}
                                                </Typography>
                                                <Typography sx={{fontSize:14,fontFamily:"dinofans",padding:1}}>
                                                    Score
                                                </Typography>
                                                <Typography sx={{fontSize:15,padding:1,color:(item?.isCorrect ? "green" : "red")}}>
                                                    {item?.score} %
                                                </Typography>
                                            </Box>
                                        )}
                                    )
                                }
                                <Typography sx={{fontSize:14,fontFamily:"dinofans",padding:1,mb:3}}>
                                    Total Score : {score} %
                                </Typography>
                            </Box>
                            }
                        </>
                    :
                    <Box width="100%">
                        <Typography sx={{fontFamily:"dinofans",fontSize:13,pb:1}}>
                           Question
                        </Typography>
                        <Typography sx={{fontSize:13,padding:1,whiteSpace:"pre-wrap"}}>
                           {content?.question}
                        </Typography>
                        {(content?.choices?.length > 0 && (content?.type.includes("selection") || content?.type.includes("true") || content?.type.includes("false")) ) && (
                            <Box justifyContent="center" alignItems="center" width="80%" mt={2} mb={2}>
                                <FormControl >
                                    <FormLabel sx={{fontFamily:"dinofans",fontSize:13,color:"#fff", mb:1}} id="demo-row-radio-buttons-group-label">Choose :</FormLabel>
                                        <RadioGroup
                                            value={message}
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            sx={{ml:2}}
                                        >
                                            {content?.choices?.map((item,index)=>(
                                                <FormControlLabel key={index} sx={{fontSize:10,mt:1}}  value={item} control={<Radio sx={{fontSize:11,color:"#ff0"}} onClick={()=>{
                                                    setMessage(item)
                                                }} />} label={<Typography sx={{fontSize:12,m:1}}>{item}</Typography>} />
                                                    ))
                                            } 
                                        </RadioGroup>                       
                                </FormControl>
                            </Box> 
                        )}
                    </Box>
                } 
                {(questions !== count && content?.type?.includes("open")) && (
                        <EditorText
                            data={message}
                            setData={setMessage}
                            width="95%"
                            label="answer"
                            isRequired={true}
                        />
                    )
                }
                <Button onClick={async (e)=>{
                    e?.preventDefault()
                    await handleSend()
                }} disabled={submitting} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
                    {
                        submitting ? 
                            <CircularProgress size={20} sx={{color:"#fff"}}/>
                        : 

                        (hasEnded ? "close" : "Send")
                    }
                </Button>
            </Box>
        </Box>
    )	
}


export default TrainQuestionView


